import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import homeDataTimeType from "../home-data-time-type/home-data-time-type.vue";
import homeSelect from "../home-select/home-select.vue";
import { getBigScreenAnalysisStaRanking } from "@/api/api-operation-service";
import homeDataBlock from "../home-data-block/home-data-block.vue";
import i18n from "@/config/i18n";
let PiHomeDataRanking = class PiHomeDataRanking extends Vue {
    constructor() {
        super(...arguments);
        this.activeSelect = "1";
        this.selectObj = {
            "1": i18n.t("homeData.revenueRanking"),
            "2": i18n.t("homeData.orderRanking"),
            "3": i18n.t("homeData.dlRanking"),
            "4": i18n.t("homeData.timeRanking"),
            "5": i18n.t("homeData.effectiveTimeRanking"),
            "6": i18n.t("homeData.userRanking"),
        };
        this.selectUnitObj = {
            "1": i18n.t("yuan"),
            "2": i18n.t("homeData.orderUnit"),
            "3": "kWh",
            "4": "",
            "5": "",
            "6": i18n.t("unitText.people"),
        };
        this.selectVisible = false;
        this.rankingList = [];
        this.active = "1";
    }
    getVisible() {
        this.getBigScreenAnalysisStaRanking();
    }
    tabChange(active) {
        this.active = active;
        this.getBigScreenAnalysisStaRanking();
    }
    selectItemClick(val) {
        this.selectVisible = false;
        this.activeSelect = val;
        this.getBigScreenAnalysisStaRanking();
    }
    async getBigScreenAnalysisStaRanking() {
        const ret = await getBigScreenAnalysisStaRanking({
            oprPkId: this.oprPkId,
            dateType: this.activeSelect,
            timeType: this.active,
        });
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data || [];
            const total = ret.data && ret.data[0] ? ret.data[0].value : 0;
            data.map((item, index) => {
                if (index == 0) {
                    item.progress = "100%";
                }
                else {
                    item.progress = ((item.value / total) * 100).toFixed(2) + "%";
                }
            });
            this.rankingList = data;
        }
    }
    mounted() {
        this.getBigScreenAnalysisStaRanking();
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeDataRanking.prototype, "oprPkId", void 0);
__decorate([
    Watch("oprPkId")
], PiHomeDataRanking.prototype, "getVisible", null);
PiHomeDataRanking = __decorate([
    Component({
        components: {
            "pi-home-data-time-type": homeDataTimeType,
            "pi-home-select": homeSelect,
            "pi-home-data-block": homeDataBlock,
        },
    })
], PiHomeDataRanking);
export default PiHomeDataRanking;
